import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Fab from '@mui/material/Fab';
import { useTranslation } from 'react-i18next';

import LightTooltip from 'src/common/components/styled/LightTooltip';

interface Props {
  onSave: () => void;
  onCancel: () => void;
  saving?: boolean;
  bottom?: number;
}

export default function PageEditorActionFab({
  onSave,
  onCancel,
  saving = false,
  bottom = 16,
}: Props) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom,
        right: 64,
        zIndex: theme => theme.zIndex.speedDial,
        display: 'flex',
        flexDirection: 'row-reverse',
        gap: 1,
      }}
    >
      <LightTooltip title={t('form.save')} placement="top">
        <Fab
          color="primary"
          aria-label={t('form.save')}
          onClick={onSave}
          disabled={saving}
        >
          {saving ? <CircularProgress size={24} color="inherit" /> : <SaveIcon />}
        </Fab>
      </LightTooltip>
      <LightTooltip title={t('base.cancel')} placement="top">
        <Fab
          color="error"
          aria-label={t('base.cancel')}
          onClick={onCancel}
          disabled={saving}
        >
          <CloseIcon />
        </Fab>
      </LightTooltip>
    </Box>
  );
}
